export class UserSession {
  constructor(
    public accountId: number,
    public userId: number,
    public firstLogin: boolean
  ) {}
}
